export enum IntBool {
  True = 1,
  False = 0,
}

export enum StringBool {
  True = '1',
  False = '0',
}
